import { concat, startWith } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

export const NO_OP = { type: 'NO_OP' };

export const startWithEndWith = (startAction = NO_OP, endAction = NO_OP) => stream$ => stream$.pipe(
  concat(of(endAction)),
  startWith(startAction),
);
